import { P2GIcon, P2GTooltip, SvgDeleteBin } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

type DeleteItemProps = {
  onRemove: (id: string) => void;
  name: string;
  index: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

export const DeleteItem = ({ onRemove, name, index, size }: DeleteItemProps) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  return (
    <P2GTooltip title={t('DELETE_BASKET_ITEM_TOOLTIP', { defaultValue: 'Delete' })}>
      <P2GIcon
        onClick={() => onRemove(name)}
        size={size}
        palette="primary"
        dataTestId={`basket-item-header-remove-${index}`}
      >
        <SvgDeleteBin />
      </P2GIcon>
    </P2GTooltip>
  );
};
